<script lang="ts" setup>
import BonusChangeForm from '@modules/players-bonuses/submodules/components/BonusChangeForm/BonusChangeForm.vue';
import {
  TRANSLATION_PLAYER_BONUS_CREATE_MANUALLY,
} from '@modules/players-bonuses/submodules/create/submodules/manually-bonus-create/constants';
import {
  useManuallyCreateBonusMutation,
} from '@modules/players-bonuses/submodules/create/submodules/manually-bonus-create/mutations';

const {
  mutate: createBonus,
  errors,
  isLoading,
  clearError,
} = useManuallyCreateBonusMutation();
</script>

<template>
  <BonusChangeForm v-data-qa-auto-id="'ManuallyBonusCreate'"
    :date-label="$getTranslation(TRANSLATION_PLAYER_BONUS_CREATE_MANUALLY, 'DATE')"
    :is-loading="isLoading"
    :btn-submit-label="$getTranslation(TRANSLATION_PLAYER_BONUS_CREATE_MANUALLY, 'PLAYERS_BONUSES_ADD_BONUS')"
    :back-button-label="$getTranslation(TRANSLATION_PLAYER_BONUS_CREATE_MANUALLY, 'BACK')"
    :bonus-amount-label="$getTranslation(TRANSLATION_PLAYER_BONUS_CREATE_MANUALLY, 'BONUS_AMOUNT')"
    :aasm-state-label="$getTranslation(TRANSLATION_PLAYER_BONUS_CREATE_MANUALLY, 'AASM_STATE')"
    :cid-label="$getTranslation(TRANSLATION_PLAYER_BONUS_CREATE_MANUALLY, 'CID')"
    :errors="errors"
    @submit="createBonus"
    @interacted="clearError"
  />
</template>
